import axios from 'axios'

const apiUrl = 'https://api.github.com'

const api = axios.create({
  baseUrl: apiUrl,
})

export default api
